import { useEffect, useMemo, useState } from 'react';
import type { AvailabilityView, SlotView } from '@masterzapis/types';
import { dayNumber, monthLabel, weekDayLabel } from '../format';

interface Props {
  availability: AvailabilityView;
  /** Дата приходит вместе со слотом: она уже в таймзоне мастера */
  onSelect: (slot: SlotView, date: string) => void;
}

export function TimePicker({ availability, onSelect }: Props) {
  const openDays = useMemo(
    () => availability.days.filter((day) => day.slots.length > 0),
    [availability],
  );

  const [selectedDate, setSelectedDate] = useState<string | null>(
    openDays[0]?.date ?? null,
  );

  // Свободное время пересчитывается при каждом открытии экрана: выбранный
  // день мог оказаться занят, пока клиент раздумывал
  useEffect(() => {
    setSelectedDate((current) =>
      current && openDays.some((day) => day.date === current)
        ? current
        : (openDays[0]?.date ?? null),
    );
  }, [openDays]);

  if (openDays.length === 0) {
    return (
      <div className="empty-state">
        На ближайшие дни свободного времени нет.
        <br />
        Напишите мастеру напрямую.
      </div>
    );
  }

  const slots = openDays.find((day) => day.date === selectedDate)?.slots ?? [];

  return (
    <div>
      <p className="section-title">Дата</p>
      <div className="days">
        {openDays.map((day) => (
          <button
            key={day.date}
            className={`day${day.date === selectedDate ? ' selected' : ''}`}
            onClick={() => setSelectedDate(day.date)}
          >
            <span className="day-week">{weekDayLabel(day.date)}</span>
            <span className="day-number">{dayNumber(day.date)}</span>
            <span className="day-week">{monthLabel(day.date)}</span>
          </button>
        ))}
      </div>

      <p className="section-title">Время · {availability.timezoneOffset}</p>
      <div className="slots">
        {slots.map((slot) => (
          <button
            key={slot.startsAt}
            className="slot"
            onClick={() => onSelect(slot, selectedDate ?? '')}
          >
            {slot.time}
          </button>
        ))}
      </div>
    </div>
  );
}
